import React from "react";
import { URGENCY_THEME } from "@/lib/kdsTimer";

export default function KdsUrgencyLegend({ alertMinutes = 15 }) {
  const warnMinutes = Math.max(5, alertMinutes - 5);

  return (
    <div
      className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-slate-600 mb-3"
      data-testid="kds-urgency-legend"
    >
      {(["fresh", "warning", "critical"]).map((key) => (
        <span key={key} className="inline-flex items-center gap-1.5">
          <span className={`h-2.5 w-2.5 rounded-full ${URGENCY_THEME[key].dot}`} />
          <span className="font-medium">{URGENCY_THEME[key].label}</span>
          {key === "fresh" && <span className="text-slate-400">(&lt;{warnMinutes}m)</span>}
          {key === "warning" && (
            <span className="text-slate-400">
              ({warnMinutes}–{alertMinutes - 1}m)
            </span>
          )}
          {key === "critical" && <span className="text-slate-400">({alertMinutes}m+)</span>}
        </span>
      ))}
    </div>
  );
}
